import 'apps/pathways/styles/components/pathways/masthead.scss';
import React from 'react';
import { Link } from 'library/util/core-router';
import PathwayOverview from 'apps/pathways/components/pathway-overview';
import PathwayStats from 'apps/pathways/components/pathway-stats';
import loadGraphData from 'util/hoc/with-data';
import SelectPathway from 'apps/pathways/components/header/select-pathway';
import withConfig from 'util/hoc/with-config';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';

const SelectWithData = loadGraphData(SelectPathway, __LANGUAGE__, 300, true);

class Masthead extends React.Component {
  constructor(...params) {
    super(...params);

    this.state = {
      fidelity: 0.01,
      scale: 0.18,
      start: 3.54,
      amplitude: 143
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((nextState) => {
      nextState[name] = parseFloat(parseFloat(value).toFixed(2));
      return nextState;
    });
  }

  changePathway = (e) => {
    const { value } = e.target;
    this.props.changePathway(value);
  }

  render() {
    const {
      fidelity,
      scale,
      start,
      amplitude
    } = this.state;

    const {
      configuration,
      data
    } = this.props;

    return (
      <div className="pathway-masthead">
        <SelectWithData pathway={data} onChange={this.changePathway} />
        <PathwayOverview
          fidelity={fidelity}
          scale={scale}
          start={start}
          amplitude={amplitude}
          steps={data.steps}
          startName={resolve(configuration, 'apps/pathways/configuration/start_name', false)}
        />
        <div className="pathway-cta">
          <Link to="/pathways/start/4">try a different pathway</Link>
        </div>
      </div>
    );
  }
}

Masthead.propTypes = {
  configuration: PropTypes.object,
  data: PropTypes.object,
  changePathway: PropTypes.func,

};

export default withConfig(Masthead);
